import React from "react";
import "./RewardModal.scss";
import CloseIcon from "../../../../images/CloseIcon.svg";
import GiftIcon from "../../../../images/GiftIcon.png";
import Animation from "../../../../images/GifWelcome.gif";
/**
 * RewardModal component description.
 *
 * @RewardModal
 *
 */

interface RewardModalProps {
  title?: string;
  key?: string;
  onClickValidate?: () => void;
  onClickClose?: () => void;
  eventType: string;
  points?: number;
}

const RewardModal: React.FC<RewardModalProps> = ({
  title,
  points,
  eventType,
  onClickValidate,
  onClickClose,
}) => {
  const getMessage = () => {
    switch (eventType) {
      case "inscription":
        return `suite à votre inscription !`;
      case "EarnedPtFromFirstOrderReward":
        return `suite à votre premier achat !`;
      case "EarnedPoints":
        return `suite à votre dernière commande !`;
      case "EarnedPtFromNbVisitsReward":
        return `suite au nombre de commandes passées !`;
      default:
        return "";
    }
  };

  const getTitle = () => {
    switch (eventType) {
      case "inscription":
        return "Récompense d'inscription";
      case "EarnedPtFromFirstOrderReward":
        return "Récompense de premier achat";
      case "EarnedPoints":
        return "Récompense de commande";
      case "EarnedPtFromNbVisitsReward":
        return "Récompense sur le nombre de visites";
      default:
        return "Félicitations !";
    }
  };

  return (
    <div className="RewardModal">
      <div className="overlay-modal">
        <div className="modal-content">
          <img className="modal-animation" src={Animation} alt="" />
        
          <img
            className="closebtn"
            src={CloseIcon}
            alt=""
            onClick={onClickClose}
            style={{ cursor: "pointer" }}
          />
          <div className="modal-header">
            <div className="GiftIcon">
              <img src={GiftIcon} alt="" />
            </div>
            <h1>Bravo !</h1>
            <h2>{getTitle()}</h2>
            <p>
              {title || (
                <>
                  Vous avez gagné <span>{points}</span> points de fidélité{" "}
                  {getMessage()}
                </>
              )}
            </p>
          </div>
          <div className="modal-footer">
            <button onClick={onClickValidate}>
              Cliquez ici pour consulter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardModal;
